<template>
  <div class="menu" :class="[{active: isActive}]">
    <base-language />
    <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'search' })">
      <svg class="menu__search" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.826 13.5431L11.8831 10.6003C12.7329 9.4896 13.2389 8.10186 13.2389 6.59887C13.2389 2.9602 10.2787 0 6.6403 0C4.87756 0 3.2202 0.686765 1.97412 1.93281C0.728043 3.17925 0.0412598 4.83617 0.0412598 6.59887C0.0412598 10.2371 3.00153 13.1973 6.6403 13.1973C8.14333 13.1973 9.53111 12.6917 10.6418 11.8416L13.5847 14.7848C13.8717 15.0717 14.3366 15.0717 14.6236 14.7848L14.826 14.5815C15.113 14.2946 15.113 13.8296 14.826 13.5427V13.5431ZM6.63951 11.4662C3.95553 11.4662 1.77203 9.28278 1.77203 6.59887C1.77203 5.29875 2.27844 4.07639 3.1981 3.15675C4.11775 2.23712 5.34015 1.73152 6.6403 1.73152C9.32428 1.73152 11.5074 3.91496 11.5074 6.59887C11.5074 9.28278 9.32389 11.4662 6.6403 11.4662H6.63951Z"
              fill="currentColor"/>
      </svg>
    </router-link>
    <div class="menu__top" v-if="user">
      <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'cart' })">
        <div class="menu__counter">{{ productInCartQuantity }}</div>
        <svg viewBox="0 0 32 32" width="40" id="svg5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" fill="currentColor">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <defs id="defs2"></defs>
            <g id="layer1" transform="translate(-12,-292)"> <path d="m 21,316.00586 c -1.645008,0 -3,1.35499 -3,3 0,1.64501 1.354992,3 3,3 1.645008,0 3,-1.35499 3,-3 0,-1.64501 -1.354992,-3 -3,-3 z m 0,2 c 0.564129,0 1,0.43587 1,1 0,0.56413 -0.435871,1 -1,1 -0.564129,0 -1,-0.43587 -1,-1 0,-0.56413 0.435871,-1 1,-1 z" id="circle5400"></path> <path d="m 35.999999,316.00586 c -1.645008,0 -3,1.35499 -3,3 0,1.64501 1.354992,3 3,3 1.645008,0 3,-1.35499 3,-3 0,-1.64501 -1.354992,-3 -3,-3 z m 0,2 c 0.564129,0 1,0.43587 1,1 0,0.56413 -0.435871,1 -1,1 -0.564129,0 -1,-0.43587 -1,-1 0,-0.56413 0.435871,-1 1,-1 z" id="circle5402"></path> <path d="m 15,294.00586 c -0.552285,0 -1,0.44772 -1,1 0,0.55228 0.447715,1 1,1 h 1.179688 l 2.65039,13.24219 C 17.759297,309.70823 17,310.77542 17,312.00586 c 0,1.6447 1.355301,3 3,3 h 18.011718 c 0.552285,0 1,-0.44772 1,-1 0,-0.55228 -0.447715,-1 -1,-1 H 20 c -0.571296,0 -1,-0.4287 -1,-1 0,-0.5713 0.428704,-1 1,-1 h 16.011718 3 c 0.492161,2.4e-4 0.911339,-0.35764 0.988281,-0.84375 l 1.730469,-11 c 0.09599,-0.60725 -0.373487,-1.15652 -0.988281,-1.15625 H 18.619141 l -0.638672,-3.19531 C 17.887292,294.34287 17.476874,294.00603 17,294.00586 Z m 4.019531,6 h 20.552734 l -1.416016,9 L 20.820312,309 Z m 3.980469,2 c -0.552285,0 -1,0.44772 -1,1 0,0.55228 0.447715,1 1,1 h 13.011718 c 0.552285,0 1,-0.44772 1,-1 0,-0.55228 -0.447715,-1 -1,-1 z m 2,3 c -0.552285,0 -1,0.44772 -1,1 0,0.55228 0.447715,1 1,1 h 9.011718 c 0.552285,0 1,-0.44772 1,-1 0,-0.55228 -0.447715,-1 -1,-1 z" id="path5404"></path> </g>
          </g>
        </svg>
      </router-link>
      <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'profile' })">
        <svg viewBox="0 0 24 24" width="45" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <g>
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-4.987-3.744A7.966 7.966 0 0 0 12 20c1.97 0 3.773-.712 5.167-1.892A6.979 6.979 0 0 0 12.16 16a6.981 6.981 0 0 0-5.147 2.256zM5.616 16.82A8.975 8.975 0 0 1 12.16 14a8.972 8.972 0 0 1 6.362 2.634 8 8 0 1 0-12.906.187zM12 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path>
            </g>
          </g>
        </svg>
      </router-link>
    </div>
    <div class="menu__buttons" v-else>
      <button class="menu__buttons-button" @click="goAuth('signIn')">{{ t('buttons.login') }}</button>
      <button class="menu__buttons-button" @click="goAuth('signUp')">{{ t('buttons.signUp') }}</button>
    </div>
    <nav class="menu__nav">
      <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'store' })" class="menu__nav-item">{{ t('header.nav.all') }}</router-link>
      <router-link
          @click="closeModal"
          class="menu__nav-item"
          v-for="category in categories"
          :key="category.node.uuid"
          :to="translations.i18nRoute({ name: 'store', query: { category: category.node.name } })"
      >
        {{ category.node.name }}
      </router-link>
    </nav>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {useAuthStore} from "@/stores/auth.js";
import translations from "@/core/helpers/translations.js";
import {useCartStore} from "@/stores/cart.js";
import {useAppStore} from "@/stores/app.js";
import BaseLanguage from "@/components/base/base-language.vue";

const route = useRoute()
const router = useRouter()
const {t} = useI18n()
const authStore = useAuthStore()
const cartStore = useCartStore()
const appStore = useAppStore()

const props = defineProps({
  isActive: Boolean,
  categories: Array,
})
const emit = defineEmits(['close-modal'])

const closeModal = () => {
  emit('close-modal');
}

const productInCartQuantity = computed(() => {
  let count = 0
  cartStore.currentOrder.orderProducts?.edges.forEach((el) => {
    count = count + el.node.quantity
  })

  return count
})

const user = computed(() => {
  return authStore.user
})

const goAuth = (modal) => {
  closeModal()
  appStore.setActiveState(modal)
}
</script>

<style lang="scss" scoped>
.menu {
  cursor: default;
  display: none;
  position: fixed;
  z-index: 2;
  top: 92px;
  right: 0;
  width: 250px;
  height: 100vh;
  background-color: $main;
  padding: 20px 40px;
  visibility: hidden;
  transform: translateX(100%);
  transition: transform 0.3s, visibility 0s 0.3s;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  &.active {
    visibility: visible;
    transform: translateX(0);
    transition: transform 0.3s;
  }

  &__search {
    width: 35px;
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;

    &-button {
      cursor: pointer;
      padding: 5px 15px;
      border-radius: 4px;
      font-family: Poppins, sans-serif;
      background-color: $white;
      color: $main;
      font-size: 16px;
      font-weight: 500;
      transition: 0.2s;

      @include hover {
        color: $yellow;
      }
    }
  }

  &__counter {
    position: absolute;
    top: -5px;
    right: -10px;
    border-radius: 50%;
    background-color: $yellow;
    width: 20px;
    aspect-ratio: 1;
    display: grid;
    place-items: center;

    font-family: Poppins, sans-serif;
    font-size: 14px;
    color: $black;
    font-weight: 600;
  }

  &__nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    &-item {
      font-size: 16px;
      font-weight: 600;
      color: $white;
    }
  }
}

svg {
  cursor: pointer;
  transition: 0.2s;
  color: $white;

  @include hover {
    color: $yellow;
  }
}

a {
  position: relative;
}

:deep(.switcher__menu) {
  top: 30px;
}

@media (max-width: 800px) {
  .menu {
    display: flex;
  }
}
</style>